/**
 * @generated SignedSource<<8353713c0bee4b6aad98f970a91e4d33>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BeforeFirstCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DragActionsButton" | "siblingIssueCreateButton_nativeIssueTable">;
  readonly " $fragmentType": "BeforeFirstCell";
};
export type BeforeFirstCell$key = {
  readonly " $data"?: BeforeFirstCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"BeforeFirstCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "BeforeFirstCell",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isReparentingEnabled",
          "variableName": "isReparentingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "DragActionsButton"
    },
    {
      "kind": "FragmentSpread",
      "name": "siblingIssueCreateButton_nativeIssueTable"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "bd3217e88c79f770b5aec35587e91367";

export default node;
